// Score box (ui-qol §2.2): "Score: {n}" in 12.5u Ubuntu, white on a black 30 % box (radius 3u,
// 17.5u tall), 15 px from the bottom-left corner. From OWN.score (floored; 10 at spawn); hidden
// while not alive. Writes the DOM only when the text changes (it is called every frame).
//
// Consumer: app.ts.

import { h } from '../dom.js';
import { t } from '../i18n/t.js';

export interface ScoreHud {
  readonly el: HTMLElement;
  /** null hides it. */
  set(score: number | null): void;
}

/** "Score: {n}" with the floored score (mechanics §13.1). */
export function scoreText(score: number): string {
  return t('hud.score', { n: Math.max(0, Math.floor(score)) });
}

export function createScore(): ScoreHud {
  const el = h('div', { class: 'hud-box hud-score', hidden: true });
  let shown: number | null = null;
  return {
    el,
    set(score: number | null): void {
      const next = score === null || !Number.isFinite(score) ? null : Math.floor(score);
      if (next === shown) return;
      shown = next;
      if (next === null) {
        el.hidden = true;
        return;
      }
      el.textContent = scoreText(next);
      el.hidden = false;
    },
  };
}
